import { cn } from "@reactive-resume/utils";
import type { ReactNode } from "react";

type DocumentGridProps = {
  children: ReactNode;
  className?: string;
};

export const DocumentGrid = ({ children, className }: DocumentGridProps) => {
  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-5",
        "sm:grid-cols-2",
        "xl:grid-cols-3",
        "2xl:grid-cols-4",
        className,
      )}
    >
      {children}
    </div>
  );
};
